/* Http Request Client */
import request from '@/utils/http/request'




export const _STATUS = {
    0: "未審核",
    1: "已審核",
    2: "審核完成",
    3: "開票完成",
    4: "開票失敗",
    6: "審核失敗",
}
//List
export async function fetchAll({ status, pageSize, pageNumber }) {
    return await request.get('/invoice', {
        params: {
            status, pageSize, pageNumber
        }

    });
}


export async function changeStatus(id, status) {
    return await request.put(`/invoice/status/${id}`, {
        status
    });
}